import React, { useState } from "react";
import { useSelector } from "react-redux";
import { postRequest } from "../../services/mainApp.service";

const RiderSelectModal = ({ riders, onRiderSelect, isModalOpen, setIsModalOpen, orderDetials, setSelectedRider }) => {
    
    const userData = useSelector((state) => state.authReducer);
    const { userBranchList } = useSelector((state) => state.authReducer);
    const [selectedRiderId, setSelectedRiderId] = useState(null);

    const filteredRiders = riders?.filter(
        (rider) => rider?.BranchId === orderDetials?.BranchId
      );
      
      console.log('checking order details', orderDetials?.BranchId)
      console.log("checking riders", riders)
      console.log("checking filtered riders", filteredRiders)

    const handleSelect = (id) => {
        setSelectedRiderId(id);
    };

    const handleAssign = () => {
        const selectedRider = riders?.find(r => r.RiderId === selectedRiderId);
        onRiderSelect(selectedRider || null);
        setSelectedRider(selectedRider?.RiderName)
        setIsModalOpen(false);
        setSelectedRiderId(null);

        postRequest("UpdateCoverWaiterRider", {
            OperationId: 4,
            RiderId: selectedRiderId,
            OrderMasterId: orderDetials?.OrderMasterId,
            userId: userData?.userId,
        
        })
            .then((response) => {
                if (response.data.error === true) {
                    message.error(response.data.errorMessage);
                    return;
                }

                if (response.data.response === false) {
                    message.error(response.data.DataSet.Table.errorMessage);
                    return;
                }

                const data = response.data.DataSet;
                
                console.log("Rider assigned successfully:", data);
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const handleClose = () => {
        setIsModalOpen(false);
        setSelectedRiderId(null);
    };

    if (!isModalOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white w-full max-w-md mx-auto rounded-xl p-6 shadow-lg relative">
                <h2 className="text-2xl font-bold mb-4 text-center">Select a Rider</h2>

                <div className="max-h-64 overflow-y-auto border rounded-lg divide-y">
                    {
                        filteredRiders?.length > 0 ? (
                            filteredRiders?.map((rider) => (
                                <div
                                    key={rider.RiderId}
                                    onClick={() => handleSelect(rider.RiderId)}
                                    className={`cursor-pointer px-4 py-3 flex items-center justify-between transition-all duration-200 ${selectedRiderId === rider.RiderId
                                            ? "bg-blue-100 text-blue-800 font-semibold"
                                            : "hover:bg-gray-100"
                                        }`}
                                >
                                    <span>{rider.RiderName}</span>
                                    {selectedRiderId === rider.RiderId && (
                                        <span className="text-sm bg-blue-600 text-white px-2 py-0.5 rounded">Selected</span>
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className="px-4 py-3 text-center text-gray-500">No riders available for this branch.</div>
                        )
                    }
                </div>

                <div className="flex justify-end gap-3 mt-6">
                    <button
                        onClick={handleClose}
                        className="w-full px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 transition"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleAssign}
                        disabled={selectedRiderId === null}
                        className={`w-full px-4 py-2 rounded-lg text-white transition ${selectedRiderId === null
                                ? "bg-gray-400 cursor-not-allowed"
                                : "bg-blue-600 hover:bg-blue-700"
                            }`}
                    >
                        Assign
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RiderSelectModal;
